import { FaSignOutAlt } from "react-icons/fa";
const IS_POS = process.env.REACT_APP_IS_POS;

// Timesheet Menu Items (without showtask and is_admin conditions)
const TimesheetMenuItems = [
  {
    title: "Dashboard",
    icon: "home",
    type: "link",
    path: `${process.env.PUBLIC_URL}/timesheetportal`,
    badge: "badge badge-light-primary",
    active: false,
    children: [],
  },
  {
    title: "My projects",
    icon: "project",
    path: `${process.env.PUBLIC_URL}/viewproject`,
    type: "link",
    badge: "badge badge-light-primary",
    active: false,
    children: [],
  },
  {
    title: "My tasks",
    icon: "project",
    path: `${process.env.PUBLIC_URL}/viewtask`,
    type: "link",
    badge: "badge badge-light-primary",
    active: false,
    children: [],
  },
  {
    title: "Timesheet report",
    icon: "widget",
    path: `/project`,
    type: "sub",
    badge: "badge badge-light-primary",
    active: false,
    children: [
      {
        path: `${process.env.PUBLIC_URL}/timesheetreport`,
        title: "My projects",
        type: "link",
      },
      {
        path: `${process.env.PUBLIC_URL}/timesheetreport-task`,
        title: "My tasks",
        type: "link",
      },
    ],
  },
  {
    title: "Working hours",
    icon: "widget",
    path: ``,
    type: "sub",
    badge: "badge badge-light-primary",
    active: false,
    children: [
      {
        path: `${process.env.PUBLIC_URL}/workinghoursreport`,
        title: "My projects",
        type: "link",
        active: false,
      },
      {
        path: `${process.env.PUBLIC_URL}/workinghoursreport-task`,
        title: "My tasks",
        type: "link",
        active: false,
      },
    ],
  },
  {
    title: "My login hours",
    icon: "project",
    path: `${process.env.PUBLIC_URL}/loginhoursreport`,
    type: "link",
    badge: "badge badge-light-primary",
    active: false,
    children: [],
  },
  {
    title: "Missing Logout list",
    icon: "project",
    path: `${process.env.PUBLIC_URL}/missinglogoutreport`,
    type: "link",
    badge: "badge badge-light-primary",
    active: false,
    children: [],
  },
  {
    title: "My Absent list",
    icon: "project",
    path: `${process.env.PUBLIC_URL}/absencereport`,
    type: "link",
    badge: "badge badge-light-primary",
    active: false,
    children: [],
  },
  {
    title: "Leave Approval list",
    icon: "project",
    path: `${process.env.PUBLIC_URL}/approvalslist`,
    type: "link",
    badge: "badge badge-light-primary",
    active: false,
    children: [],
  },
  {
    title: "My break hours",
    icon: "project",
    path: `${process.env.PUBLIC_URL}/breakhoursreport`,
    type: "link",
    badge: "badge badge-light-primary",
    active: false,
    children: [],
  },
  {
    title: "Attendence Report",
    icon: "project",
    path: `${process.env.PUBLIC_URL}/attendencereport`,
    type: "link",
    badge: "badge badge-light-primary",
    active: false,
    children: [],
  },
  {
    title: "Monthly Timesheet Report",
    icon: "project",
    path: `${process.env.PUBLIC_URL}/monthlytimesheetreport`,
    type: "link",
    badge: "badge badge-light-primary",
    active: false,
    children: [],
  },
  {
    title: "Employeewise Report",
    icon: "project",
    path: `${process.env.PUBLIC_URL}/employeewisereport`,
    type: "link",
    badge: "badge badge-light-primary",
    active: false,
    children: [],
  },
  {
    title: "Chat",
    icon: "project",
    type: "link",
    badge: "badge badge-light-primary",
    active: false,
    children: [],
  },
  {
    title: "Logout",
    icon: <FaSignOutAlt />,
    type: "link",
    badge: "badge badge-light-primary",
    active: false,
    children: [],
  },
];

// Pos Menu Items
const PosMenuItems = [
  {
    title: "Dashboard",
    icon: "home",
    type: "link",
    path: `${process.env.PUBLIC_URL}/dashboardposmain`,
    badge: "badge badge-light-primary",
    active: false,
  },
  {
    title: "Logout",
    icon: <FaSignOutAlt />,
    path: `${process.env.PUBLIC_URL}/login`,
    type: "link",
    badge: "badge badge-light-primary",
    active: false,
  },
];

// Honest Chart Menu Items
const HonestChartItems = [
  {
    title: "Dashboard",
    icon: "home",
    type: "link",
    path: `${process.env.PUBLIC_URL}/dashboard`,
    badge: "badge badge-light-primary",
    active: false,
  },
  {
    title: "Logout",
    icon: <FaSignOutAlt />,
    type: "link",
    badge: "badge badge-light-primary",
    active: false,
  },
];

export const MENUITEMS = [
  {
    menutitle: "General",
    menucontent: "Dashboards,Widgets",
    Items: [
      ...(IS_POS == "0" ? TimesheetMenuItems : []),
      ...(IS_POS == "1" ? PosMenuItems : []),
      ...(IS_POS == "3" ? HonestChartItems : []),
    ],
  },
];